import React from 'react';

export default function Img({ src, alt, className, onClick }) {
  // Function to generate srcset
  const generateSrcSet = (src) => {
    const widths = [640, 750, 828, 1080, 1200, 1920, 2048, 3840];
    return widths.map(width => `${src}?w=${width} ${width}w`).join(', ');
  };

  return (
    <img
      src={src}
      srcSet={generateSrcSet(src)}
      sizes="100vw"
      alt={alt}
      className={className}
      onClick={onClick}
      style={{ width: '100%', height: 'auto' }}
      loading="lazy"
    />
  );
}